import { IApplicationState } from '../../../../../types/types';
import { getAuthUserMetaMyWork } from '../../../../../store/model/selectors/getAuthUserMetaMyWork';

export const getMyWorkFilterBarCollapsed = (
    state: IApplicationState
): boolean => {
    const meta = getAuthUserMetaMyWork(state);
    return meta && meta.isFilterBarCollapsed;
};
